import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {DBHeaderLinkConfigDirective, NBHeaderModule} from '@db/db-components';
import { DBIconModule } from '@db/db-core';

@Component({
  selector: 'app-header-nb',
  templateUrl: './header-nb.component.html',
  styleUrls: ['./header-nb.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NBHeaderModule,
    DBIconModule,
    DBHeaderLinkConfigDirective
  ]
})
export class NbHeaderComponent implements OnInit {
  constructor(private auth: AuthService) {
  }

  get isAuthenticated$() {
    return this.auth.isAuthenticated$;
  }

  ngOnInit() {}

  onLogout() {
    this.auth.logout();
  }
}
